"use strict";
/*
 * Copyright (c) 2018 - Present, Vamstar Limited
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or
 * without modification, are not permitted.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentTerm = void 0;
/**
 * @description Payment terms dropdown list
 */
var PaymentTerm;
(function (PaymentTerm) {
    PaymentTerm["UPFRONT_PAYMENT"] = "UPFRONT_PAYMENT";
    PaymentTerm["LETTER_OF_CREDIT"] = "LETTER_OF_CREDIT";
    PaymentTerm["DOCUMENTS"] = "DOCUMENTS";
    PaymentTerm["TEN_DAYS_PAYMENT_TERMS"] = "TEN_DAYS_PAYMENT_TERMS";
    PaymentTerm["TWENTYONE_DAYS_PAYMENT_TERMS"] = "TWENTYONE_DAYS_PAYMENT_TERMS";
    PaymentTerm["MILESTONE_PAYMENTS"] = "MILESTONE_PAYMENTS";
    PaymentTerm["OTHER"] = "OTHER";
})(PaymentTerm = exports.PaymentTerm || (exports.PaymentTerm = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicGF5bWVudC10ZXJtLmVudW0uanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvcmZxL3R5cGVzL3BheW1lbnQtdGVybS5lbnVtLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFBQTs7Ozs7O0dBTUc7OztBQUVIOztHQUVHO0FBQ0gsSUFBWSxXQVFYO0FBUkQsV0FBWSxXQUFXO0lBQ3JCLGtEQUFtQyxDQUFBO0lBQ25DLG9EQUFxQyxDQUFBO0lBQ3JDLHNDQUF1QixDQUFBO0lBQ3ZCLGdFQUFpRCxDQUFBO0lBQ2pELDRFQUE2RCxDQUFBO0lBQzdELHdEQUF5QyxDQUFBO0lBQ3pDLDhCQUFlLENBQUE7QUFDakIsQ0FBQyxFQVJXLFdBQVcsR0FBWCxtQkFBVyxLQUFYLG1CQUFXLFFBUXRCIn0=